import { atom } from "jotai";

export const CurrentStepAtom = atom(1);
